// extracted by mini-css-extract-plugin
module.exports = {"welcomeModal":"welcome_welcomeModal__eR3dc","logo":"welcome_logo___4HYP","explorerBtn":"welcome_explorerBtn__KXDAl"};